import { render } from "./CollapsableTable.vue?vue&type=template&id=2c5c9a38"
import script from "./CollapsableTable.vue?vue&type=script&lang=js"
export * from "./CollapsableTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/survey-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__